import React from "react";
//import { makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import classes from "./Footer.module.css";
import OsloMetLogo from "../Logo/Logo";

/*const useStyles = makeStyles(() => ({
//add style content here for use of style function
}));*/

export default function Footer() {
//const classes = useStyles();
  return (
    <div>
      <Toolbar className={classes.toolbar}>
          <Typography className={classes.text}>
                  Thora Mothes, Martina Førre<br/>
                  Tara Jørgensen, Mathias Ahrn
          </Typography>
              <OsloMetLogo height="5em"/>
      </Toolbar>
    </div>
  );
}
